import http from 'common/http'
import * as c from 'common/c'
import { toLonLat } from 'ol/proj'
import type { Coordinate } from 'ol/coordinate'

export const fetchMarkers = (year: number) => {
  return (dispatch) => {
    return http.get('/marker', { params: { year } }).then((res) => {
      dispatch({ type: c.MARKERS_FETCHED, payload: res.data.results })
    })
  }
}

export const fetchMarkerTypes = () => {
  return (dispatch) => {
    return http.get('/marker/type').then((res) => {
      dispatch({ type: c.MARKER_TYPES_FETCHED, payload: res.data.types })
    })
  }
}

export const createMarker = (
  markerTypeId: string,
  coordinate: Coordinate,
  note?: string,
) => {
  return (dispatch) => {
    const [lon, lat] = toLonLat(coordinate)
    const body = [
      {
        markerTypeId,
        geom: { type: 'Point', coordinates: [lon, lat] },
        ...(note ? { note } : {}),
      },
    ]
    return http.post('/marker', body).then((res) => {
      dispatch({ type: c.MARKER_CREATED, payload: res.data.markers })
    })
  }
}

export const deleteMarker = (id: string) => {
  return (dispatch) => {
    return http.delete(`/marker/${id}`).then(() => {
      dispatch({ type: c.MARKER_DELETED, payload: id })
    })
  }
}

export const updateMarkerNote = (id: string, note: string) => {
  return (dispatch) => {
    return http.put(`/marker/${id}`, { note }).then((res) => {
      dispatch({ type: c.MARKER_UPDATED, payload: res.data })
    })
  }
}
